import React from 'react';
import Card from '@material-ui/core/Card';
import { FormatNumber, GetNameMonth } from '../../helpers/Helpers';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CuentaSelected from '../../helpers/CuentaSelected';
import Api from '../../helpers/Api';
import Env from '../../config/env';
import Modal from '@material-ui/core/Modal';

class InvoicesList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detail: [],
      openModal: false,
      invoiceSelected: {},
    };
  }

  handleViewDetail = async (val) => {
    const account = CuentaSelected.get();
    const data = await Api.get(`${Env.UrlSeguridad}/getVDFacturaWeb/${account.cuentaCodigo}/${val.ANO}/${val.MES}`);
    if (data.cod === '1') {
      this.setState({
        detail: data.V_D_FACTURA_WEB,
        openModal: true,
        invoiceSelected: val,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  render() {
    const { data } = this.props;

    return (
      <Card>
        <table className="custom-table">
          <thead>
            <tr>
              <th>Periodo</th>
              <th>Valor</th>
              <th>Detalle</th>
              <th>CUFE</th>
            </tr>
          </thead>
          <tbody>
            {data.map((val, index) => {
              return (
                <tr key={index}>
                  <td style={{ padding: '0px' }}>
                    {val.ANO} - {GetNameMonth(val.MES)}
                  </td>
                  <td style={{ padding: '0px' }}>$ {FormatNumber.new(val.VALOR)}</td>
                  <td style={{ padding: '0px' }}>
                    <Tooltip title="Ver detalle factura">
                      <IconButton
                        color="secondary"
                        onClick={() => {
                          this.handleViewDetail(val);
                        }}
                        aria-label="add to shopping cart"
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                  <td style={{ padding: '0px' }}>
                    <Tooltip title="Ver PDF CUFE">
                      <IconButton color="primary" onClick={() => window.open(`${Env.urlDIAN}${val.CUFE}`, '_blank')} aria-label="view CUFE PDF">
                        <svg style={{ width: 24, height: 24 }} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            {' '}
                            <path d="M3.5 8H3V7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8Z" fill="#000000"></path>{' '}
                            <path d="M7 10V7H7.5C7.77614 7 8 7.22386 8 7.5V9.5C8 9.77614 7.77614 10 7.5 10H7Z" fill="#000000"></path>{' '}
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M1 1.5C1 0.671573 1.67157 0 2.5 0H10.7071L14 3.29289V13.5C14 14.3284 13.3284 15 12.5 15H2.5C1.67157 15 1 14.3284 1 13.5V1.5ZM3.5 6H2V11H3V9H3.5C4.32843 9 5 8.32843 5 7.5C5 6.67157 4.32843 6 3.5 6ZM7.5 6H6V11H7.5C8.32843 11 9 10.3284 9 9.5V7.5C9 6.67157 8.32843 6 7.5 6ZM10 11V6H13V7H11V8H12V9H11V11H10Z"
                              fill="#000000"
                            ></path>{' '}
                          </g>
                        </svg>
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <Modal
          open={this.state.openModal}
          onClose={this.handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Card style={{ minWidth: '500px' }}>
            <table className="custom-table">
              <thead>
                <tr>
                  <th colSpan={2}>
                    Detalle factura {this.state.invoiceSelected.ANO} - {GetNameMonth(this.state.invoiceSelected.MES)}
                  </th>
                </tr>
                <tr>
                  <th>Periodo</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {this.state.detail.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val.CONCEPTO}</td>
                      <td style={{ textAlign: 'right' }}>$ {FormatNumber.new(val.VALOR_MES)}</td>
                    </tr>
                  );
                })}
                <tr>
                  <th>Total</th>
                  <td style={{ textAlign: 'right' }}>$ {FormatNumber.new(this.state.invoiceSelected.VALOR)}</td>
                </tr>
              </tbody>
            </table>
          </Card>
        </Modal>
      </Card>
    );
  }
}

export default InvoicesList;
